// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"style_headerTitle__2L8Zz","line":"style_line__2v_WM","fontSize1":"style_fontSize1__3rAz3","bold":"style_bold__3hfnP"};